import * as cheetahGrid from "cheetah-grid";
const RestoreIndicatorConfiguration = {
    defaultRowHeight: 30,
    headerRowHeight: 25,
    header: [
      {
        field: "version",
        caption: "Versão",
        maxWidth: "50%",
        width: "48%",
        style: { textAlign: "center", font: "11px sans-serif"},
        headerStyle: { textAlign: "center", font: "14px sans-serif"},
        headerClassName: 'super-app-theme--default'
      },
      {
        field: "timesTamp",
        caption: "Data e Hora",
        maxWidth: "50%",
        width: "50%",
        style: { textAlign: "center", font: "11px sans-serif"},
        headerStyle: { textAlign: "center", font: "14px sans-serif"},
      },
    ],
    eventType: {...cheetahGrid.ListGrid.EVENT_TYPE}
  }

  export default RestoreIndicatorConfiguration